import classNames from 'classnames'
import React from 'react'

import { useQuinceRouter as useRouter } from '@src/modules/navigation'

import { Button, BUTTON_TYPES } from '../../atoms'

import styles from './errorScreen.module.scss'

interface ErrorScreenProps {
  title?: string
  description?: string
  onButtonClick?: () => void
}

const DEFAULT_TITLE = 'It’s not you, it’s us.'
const DEFAULT_DESCRIPTION =
  'Looks like something is wrong on our end. Please go back and try again or go to our homepage.'

const ErrorScreen = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, onButtonClick }: ErrorScreenProps) => {
  const router = useRouter()
  const navigateHome = () => {
    router.push('/')
  }
  return (
    <div className={styles.wrapper}>
      <div className={classNames(styles.contentContainer)}>
        <h3 className={classNames(styles.title)}>{title}</h3>
        <p className={classNames(styles.description, 'body2_grosa')}>{description}</p>
        <Button type={BUTTON_TYPES.SECONDARY} className={styles.button} onClick={onButtonClick ?? navigateHome}>
          GO BACK
        </Button>
      </div>
    </div>
  )
}

export default ErrorScreen
